import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";

export function Corners_pred() {
  const [table3, setTable3] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const API_URL = process.env.REACT_APP_DIRECT || "http://192.168.1.103:8081";

  useEffect(() => {
    // fetching the 3 table

    fetch(`${API_URL}/table/corner_merged_analytic`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Ensure data is an array
        const dataArray = Array.isArray(data) ? data : [data];
        console.log("Raw data from API:", dataArray);

        // Function to parse "08.03. 18:00" from team_code
        const formatDateTime = (teamCode) => {
          try {
            // Extract date and time (e.g., "08.03._18:00" -> "08.03. 18:00")
            const dateTimeParts = teamCode.split("_").slice(-2);
            const datePart = dateTimeParts[0]; // "08.03."
            const timePart = dateTimeParts[1]; // "18:00"

            // Remove trailing dot from date part
            const cleanDatePart = datePart.replace(/\.$/, ""); // "08.03"

            // Use current year (2025 as of March 09, 2025)
            const currentYear = new Date().getFullYear();

            // Convert to ISO 8601 (e.g., "2025-03-08T18:00:00")
            const [day, month] = cleanDatePart.split(".");
            const isoDateTime = `${currentYear}-${month.padStart(
              2,
              "0"
            )}-${day.padStart(2, "0")}T${timePart}:00`;
            return isoDateTime;
          } catch (error) {
            console.error(`Error formatting team_code '${teamCode}': ${error}`);
            return null; // Return null for invalid team_code
          }
        };

        // Get current date/time ("now")
        const now = new Date();
        console.log("Current time (now):", now);

        // Filter data for future dates
        const filteredData = dataArray.filter((row) => {
          try {
            const formattedDateTime = formatDateTime(row.team_code);
            if (!formattedDateTime) return false;

            const rowDate = new Date(formattedDateTime);
            if (isNaN(rowDate.getTime())) {
              console.warn(
                `Invalid date parsed from team_code '${row.team_code}': ${formattedDateTime}`
              );
              return false;
            }

            const isFuture = rowDate > now;
            console.log(
              `Row team_code: ${row.team_code}, Parsed date: ${rowDate}, Is future: ${isFuture}`
            );
            return isFuture;
          } catch (error) {
            console.warn(
              `Error processing row with team_code '${row.team_code}': ${error}`
            );
            return false;
          }
        });

        console.log("Filtered data:", filteredData);

        // Set filtered data
        setTable3(filteredData);

        // Update isEmpty state
        if (filteredData.length === 0) {
          setIsEmpty(true);
        } else {
          setIsEmpty(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching table3:", error);
        setIsEmpty(true);
      });
  }, []);

  return (
    <>
      <div className="alg1_card">
        {/******* */}
        <div>
          <h1 className="head_one1">Merged Data Table</h1>
          {isEmpty ? (
            <p>No data available.</p>
          ) : (
            <Table striped>
              <thead>
                <tr>
                  <th>Schedule</th>
                  <th>H_Team</th>
                  <th>H_mean</th>
                  <th>H_cv</th>
                  <th>A_Team</th>
                  <th>A_mean</th>
                  <th>A_cv</th>
                  <th>League</th>
                  <th>H_Corners</th>
                  <th>A_corners</th>
                  <th>H-2-H(c)</th>
                  <th>Prediction</th>
                </tr>
              </thead>
              <tbody>
                {table3.map((row, index) => {
                  let homeClass = "";
                  let awayClass = "";
                  let combined = "";
                  let cellContent1 = "";

                  // Both home and away > 30 on CV
                  if (row.cv_home > 30 && row.cv_away > 30) {
                    combined = "table-danger";

                    cellContent1 = "Inconsistent";
                  }
                  // Both home and away < 30 on CV
                  else if (row.cv_home < 30 && row.cv_away < 30) {
                    combined = "table-success";
                    cellContent1 = "Good";
                  }
                  // Home < 30 on CV
                  if (row.cv_home < 30) {
                    homeClass = "table-success";
                  } else if (row.cv_home > 30) {
                    homeClass = "table-danger";
                  }
                  // Away > 30 on CV
                  if (row.cv_away > 30) {
                    awayClass = "table-danger";
                  } else if (row.cv_away < 30) {
                    awayClass = "table-success";
                  }

                  const formatDateTime = (teamCode) => {
                    // Extract the part after the last underscore
                    const dateTime = teamCode.split("_").slice(-2).join(" ");

                    // Replace any remaining underscores with spaces
                    return dateTime.replace("_", " ");
                  };

                  return (
                    <tr key={index}>
                      <td className="TeamA">{formatDateTime(row.team_code)}</td>
                      <td className="TeamA ">{row.home_team}</td>
                      <td className="TeamB ">{row.mean_corners_home}</td>
                      <td className={`${homeClass}`}>{row.cv_home}</td>
                      <td className="opt_sel">{row.away_team}</td>
                      <td className="H_EXP_G">{row.mean_corners_away}</td>
                      <td className={`rtry ${awayClass}`}>{row.cv_away}</td>
                      <td className="HP_1">{row.league}</td>
                      <td className="HP_2">{row.corner_values_home}</td>
                      <td className="H_Win">{row.corner_values_away}</td>
                      <td className="H_Win">
                        {row.Home_corners + row.Away_corners}
                      </td>
                      <td className={`rrrt ${combined}`}>{cellContent1}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
}
